const { objectives } = require('./constants.js');

function chooseAudienceVisibility({ proposal, onboarding, intel, type, objectives: [objective] = [] }) {
  const audienceProfile = proposal ? proposal.audienceProfile : onboarding.audience.value;
  const channelAds = proposal
    ? proposal.channelAds.filter(({ enabled }) => !!enabled)
    : onboarding.ads.filter(({ value }) => !!value.enabled).map(({ value }) => value);

  const isMobileApp = channelAds.some(ad => ad.creative.appStoreUrl || ad.creative.playStoreUrl) || type === 'app',
    isForm =
      channelAds.some(ad => ad.creative.url && ad.creative.url.includes('form.adriel')) ||
      type === 'form' ||
      objective === objectives.LEAD_GENERATION,
    isWeb =
      channelAds.some(ad => ad.creative.url && !ad.creative.appStoreUrl && !ad.creative.playStoreUrl) || type === 'web',
    channels = new Set(channelAds.map(({ channel }) => channel)),
    hasGoogleAds = channels.has('google') || channels.has('youtube'),
    hasAppleAds = channels.has('apple'),
    hasKakaoAds = channels.has('kakao'),
    fbFamilyOn = channels.has('facebook') || channels.has('instagram'),
    hasFacebookAppSdk = Boolean(intel.fbApp),
    hasMicrosoftAds = channels.has('microsoft'),
    hasYelpAds = new Set(proposal.channelAds.map(({ channel }) => channel)).has('yelp'),
    hasGoogleSearch = channelAds.some((ad = {}) => ad.channel === 'google' && ad.creativeType === 'ExpandedTextAd'),
    hasGoogleDisplay = channelAds.some(
      (ad = {}) => ad.channel === 'google' && ad.creativeType === 'ResponsiveDisplayAd',
    ),
    hasFbFamily = channelAds.some(({ channel } = {}) => channel === 'facebook' || channel === 'instagram'),
    hasYoutube = channels.has('youtube');

  /** website visitors **/
  const showGoogleAnalytics = isWeb && !isForm,
    showFacebookPixel = objective === objectives.CONVERSIONS || (isWeb && !isForm && fbFamilyOn),
    showFacebookSdk = isMobileApp && fbFamilyOn,
    showWebsiteVisitors = showGoogleAnalytics || showFacebookPixel || showFacebookSdk;
  updateSettings('websiteVisitors', {
    showGoogleAnalytics,
    showFacebookPixel,
    showFacebookSdk,
    visible: showWebsiteVisitors,
  });

  /** objectives **/
  const showObjectives = objective || (isWeb && !isForm);
  updateSettings('objectives', { visible: showObjectives });

  /** list of customers **/
  const showListOfCustomers = (isWeb || isForm || (isMobileApp && !hasFacebookAppSdk)) && fbFamilyOn;
  updateSettings('listOfCustomers', { visible: showListOfCustomers });

  /** interests **/
  const targetType = audienceProfile.find(x => x.name === 'targetType');
  const isInterestOn =
    !targetType ||
    !targetType.values.find(x => x.name === 'interest') ||
    targetType.values.find(x => x.name === 'interest').value;

  const showInterests = isInterestOn && (fbFamilyOn || hasKakaoAds); // TODO check with Michelle
  proposal && updateSettings('audienceInterests', { visible: showInterests });

  /** keywords **/
  const showKeywords =
    ((isWeb || isForm) && (hasGoogleAds || hasKakaoAds || hasMicrosoftAds || hasYelpAds)) ||
    (isMobileApp && (hasAppleAds || hasKakaoAds));
  proposal && updateSettings('searchKeywords', { visible: showKeywords });

  /** income **/
  const showIncome = ((isWeb || isForm) && (hasGoogleAds || hasKakaoAds)) || (isMobileApp && hasKakaoAds);
  updateSettings('income', { visible: showIncome });

  /** gender and age **/
  const showGenderAge = isWeb || isForm || (isMobileApp && (hasAppleAds || fbFamilyOn || hasKakaoAds));
  updateSettings('gender', { visible: showGenderAge });
  updateSettings('age', { visible: showGenderAge });

  /** relationship **/
  const showRelationshipStatus = isWeb || isForm || (isMobileApp && (fbFamilyOn || hasKakaoAds));
  updateSettings('relationshipStatus', { visible: showRelationshipStatus });

  /** device **/
  const showDevice = (isWeb || isForm) && (hasFbFamily || hasGoogleAds);
  updateSettings('deviceTarget', { visible: showDevice });

  /** location **/
  updateSettings('location', { visible: true });

  /** schedule **/
  const showSchedule = (isWeb || isForm) && hasGoogleAds;
  updateSettings('schedule', { visible: showSchedule });

  /** targetType **/
  updateSettings('targetType', {
    visible: fbFamilyOn || hasGoogleSearch || hasGoogleDisplay || hasYoutube,
  });

  /** videoAdFormat **/
  updateSettings('videoAdFormat', { visible: hasYoutube });

  return audienceProfile;

  function updateSettings(settingName, object) {
    const audienceSettings = audienceProfile.find(({ name }) => name === settingName);
    if (audienceSettings) Object.assign(audienceSettings, setObjForYelp(object, settingName));
  }

  function setObjForYelp(object, settingName) {
    return hasYelpAds ? { ...object, visible: settingName === 'searchKeywords' } : object;
  }
}
module.exports = { chooseAudienceVisibility };
